import { Badge, Icon } from '../../design-system/index.js'
import { sectionGap, wrap } from '../layout.js'
import SectionHead from './SectionHead.jsx'

/**
 * What the cabinet actually does, in two cards.
 *
 * Each card carries a small still of the screen it describes rather than an
 * icon: the claim and the evidence for it sit in the same box. The stills are
 * decorative (`aria-hidden`) — every one of them only repeats, in picture
 * form, what the card's own heading and body already say.
 */
export function Features({ t, desktop }) {
  return (
    <div className="u-band" style={{ marginTop: desktop ? 72 : 48 }}>
      <section
        id="features"
        aria-labelledby="features-title"
        style={{
          ...wrap(desktop),
          paddingTop: sectionGap(desktop),
          paddingBottom: sectionGap(desktop),
        }}
      >
        <SectionHead
          id="features-title"
          label={t.featuresLabel}
          title={t.featuresTitle}
          sub={t.featuresSub}
          desktop={desktop}
        />

        <ul
          style={{
            display: 'grid',
            gridTemplateColumns: desktop ? '1fr 1fr' : '1fr',
            gap: 16,
            margin: `${desktop ? 40 : 28}px 0 0`,
            padding: 0,
            listStyle: 'none',
          }}
        >
          {t.features.map(([title, body], i) => (
            <li key={title} className="u-feature">
              <h3 style={{ fontSize: desktop ? 20 : 18, margin: 0, letterSpacing: '-0.02em' }}>
                {title}
              </h3>
              <p
                style={{
                  margin: '8px 0 18px',
                  fontSize: 15,
                  color: 'var(--ink-2)',
                  lineHeight: 1.55,
                  maxWidth: 420,
                }}
              >
                {body}
              </p>
              <FeatureMock index={i} t={t} />
            </li>
          ))}
        </ul>
      </section>
    </div>
  )
}

/** A still of the screen the card is about. Decorative, in card order. */
function FeatureMock({ index, t }) {
  if (index === 0) {
    return (
      <div className="u-feature-mock" aria-hidden="true">
        {[
          ['IELTS', '6.5 / 6.5', true],
          ['GPA', '3.4 / 3.2', true],
          ['SAT', '— / 1250', false],
        ].map(([label, value, met]) => (
          <div className="u-mock-row" key={label}>
            <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
              <span
                style={{
                  display: 'inline-flex',
                  color: met ? 'var(--verified-text)' : 'var(--ink-3)',
                }}
              >
                <Icon name={met ? 'check' : 'x'} size={14} />
              </span>
              <span style={{ fontWeight: 600, color: 'var(--ink-1)' }}>{label}</span>
            </span>
            <span>{value}</span>
          </div>
        ))}
      </div>
    )
  }

  return (
    <div className="u-feature-mock" aria-hidden="true">
      <div className="u-mock-row">
        <span style={{ fontWeight: 600, color: 'var(--ink-1)' }}>chevening.org</span>
        <Badge tone="verified">
          <Icon name="check" size={13} />
          {t.verified}
        </Badge>
      </div>
      <div className="u-mock-line" style={{ width: '72%' }} />
      <div className="u-mock-line" style={{ width: '46%' }} />
    </div>
  )
}

export default Features
